module.exports = __webpack_public_path__ + "static/media/win.1e5833d5.svg";